<template>
  <div class="navbar">
    <div>
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb class="breadcrumb-container padding-left" />
    <HeaderInfo />
    </div>
    <div class="right-menu">
      <!-- 未登录不展示 -->
      <template v-if="isLogined">
        <search id="header-search" class="right-menu-item" />
        <!-- <lang-select class="right-menu-item hover-effect" /> -->
        <MessageIcon />
        <el-dropdown trigger="click" class="padding-lr">
          <div class="el-dropdown-link flex align-center" style="height: 100%">
            <div style="line-height: 1" class="text-center">
              <span v-if="userInfo.customerCode!='J0427'">{{ name }}</span>
              <div>{{ userInfo.customerCode }}</div>
            </div>
            <i class="el-icon-arrow-down el-icon--right" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="changePassword">
              {{ $t('navbar.password') }}
            </el-dropdown-item>
            <el-dropdown-item
              divided
              @click.native="$refs.customFaceSingle.dialogFormVisible = true"
            >
              <span style="display: block">自定义运单标签内容</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <span style="display: block">
                {{ $t('navbar.logOut') }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>
    <CustomFaceSingle ref="customFaceSingle" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import HeaderInfo from '@/components/HeaderInfo'
import Hamburger from '@/components/Hamburger'
import LangSelect from '@/components/LangSelect'
import Search from '@/components/HeaderSearch'
import MessageIcon from '@/components/MessageIcon'
import CustomFaceSingle from '@/components/customFaceSingle'
import { getToken } from '@/utils/auth' // get token from cookie
export default {
  components: {
    Breadcrumb,
    HeaderInfo,
    Hamburger,
    LangSelect,
    Search,
    MessageIcon,
    CustomFaceSingle,
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'name', 'userInfo']),
  },
  data() {
    return {
      isLogined: false,
    }
  },
  created() {
    this.isLogined = !!getToken()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    changePassword() {
      // this.$store.dispatch('app/togglePasswordDialog')
      this.$emit('togglePasswordDialog')
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  /*overflow: hidden;*/
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: space-between;
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    padding-right: 10px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
